import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import { Fa, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from 'mdbreact';
import { ProgressBar } from "react-bootstrap";

const ProgressBarChart = (props) => {
    const { isSecondProgressBar, data } = props;

    return (
        <>
            {data?.map((data, index) => (
                <MDBRow key={index} className="mt-2">
                    <MDBCol md="2" lg="2" className="mr-0 pr-0 pb-0" style={{ paddingLeft: '5px' }}>
                        <div style={{ fontWeight: 'bold', textAlign: 'center' }} className={"small-font toolbox-name-" + props.theme.name} title={data.nmscCode}>
                            {data.nmscCode}
                        </div>
                    </MDBCol>

                    <MDBCol md="10" lg="10" className="mr-0 pr-1 pb-2">
                        {isSecondProgressBar &&
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <ProgressBar >
                                        <ProgressBar
                                            variant="danger"
                                            now={Math.round(data?.reauditScore || data?.chapterScore?.reAudit || data?.criticalScore?.reAudit || 0)}
                                            key={1}
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title={Math.round(data?.reauditScore || data?.chapterScore?.reAudit || data?.criticalScore?.reAudit || 0)}
                                            style={{ border: "1px solid black" }}
                                        />
                                    </ProgressBar>
                                </div>
                                <div style={{ marginLeft: '8px', fontWeight: 'bold', paddingTop: "0px", minWidth: "40px", textAlign: "right" }}>
                                    {Math.round(data?.reauditScore || data?.chapterScore?.reAudit || data?.criticalScore?.reAudit || 0)}%
                                </div>
                            </div>
                        }

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flex: 1 }}>
                                <ProgressBar>
                                    <ProgressBar
                                        variant="success"
                                        now={Math.round(data.value || data?.chapterScore?.firstAudit || data?.criticalScore?.firstAudit || 0)}
                                        key={1}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={Math.round(data.value || data?.chapterScore?.firstAudit || data?.criticalScore?.firstAudit || 0)}
                                    />
                                </ProgressBar>
                            </div>
                            <div style={{ marginLeft: '8px', fontWeight: 'bold', paddingTop: "0px", minWidth: "40px", textAlign: "right" }}>
                                {Math.round(data.value || data?.chapterScore?.firstAudit || data?.criticalScore?.firstAudit || 0)}%
                            </div>
                        </div>
                    </MDBCol>
                </MDBRow>
            ))}
        </>
    );
};

const mapStateToProps = state => {
    return {
        user: state.loginReducer,
    };
};

export default connect(mapStateToProps)(withRouter(withTheme(ProgressBarChart)));